import { dossier } from '@/mocks/heiliao';

export default function DossierSection() {
  return (
    <section id="dossier" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <nav aria-label="面包屑" className="reveal mb-6 text-xs text-foreground-500">
          <ol className="flex flex-wrap items-center gap-1.5">
            <li>
              <a href="#home" className="transition-colors hover:text-primary-600">
                首页
              </a>
            </li>
            <li aria-hidden="true">/</li>
            <li>
              <a href="#dossier" className="transition-colors hover:text-primary-600">
                深度档案
              </a>
            </li>
            <li aria-hidden="true">/</li>
            <li className="text-foreground-800">第 044 期</li>
          </ol>
        </nav>

        <div className="reveal grid grid-cols-1 gap-8 lg:grid-cols-[1.6fr_1fr] lg:items-start">
          <article className="rounded-lg border border-background-300 bg-background-100 p-5 md:p-8">
            <span className="text-xs font-semibold tracking-[0.25em] text-primary-600">
              {dossier.kicker}
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              {dossier.title}
            </h2>
            <p className="mt-3 text-xs text-foreground-500">{dossier.meta}</p>

            <div className="mt-6 overflow-hidden rounded-lg">
              <img
                src={dossier.cover}
                alt="深度档案封面：整理成档案馆文件夹样式的话题资料"
                className="h-[240px] w-full object-top object-cover md:h-[340px]"
              />
            </div>

            <div className="mt-7 space-y-7">
              {dossier.blocks.map((block, index) => (
                <div key={block.heading} id={`dossier-block-${index + 1}`} className="scroll-mt-32">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{block.heading}</h3>
                  <p className="mt-2.5 text-sm leading-7 text-foreground-700">{block.body}</p>
                </div>
              ))}
            </div>
          </article>

          <aside className="rounded-lg border border-background-300 bg-background-50 p-5 md:p-6 lg:sticky lg:top-24">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-list-check-2 text-primary-600"></i>
              本期内容目录
            </h3>
            <ol className="mt-4 space-y-2.5">
              {dossier.blocks.map((block, index) => (
                <li key={block.heading}>
                  <a
                    href={`#dossier-block-${index + 1}`}
                    className="flex items-start gap-2.5 rounded-md px-3 py-2 text-xs leading-relaxed text-foreground-700 transition-colors hover:bg-background-200 hover:text-foreground-950"
                  >
                    <span className="font-heading font-bold text-primary-600">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    {block.heading.replace(/^[一二三四五六七八九十]+、/, '')}
                  </a>
                </li>
              ))}
            </ol>

            <div className="mt-5 rounded-md border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-center gap-2 text-xs font-semibold text-accent-800">
                <i className="ri-information-line"></i>
                内容原则
              </p>
              <p className="mt-2 text-xs leading-relaxed text-foreground-700">
                本目录只整理公开可见、可回溯的信息，不发布未经证实的指控，也不针对真实个人给出评价性结论。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}